import { ArrowLeft } from 'lucide-react';

interface PageHeaderProps {
  title: string;
  eyebrow?: string;
  onBack?: () => void;
}

export function PageHeader({ title, eyebrow, onBack }: PageHeaderProps): JSX.Element {
  return (
    <header
      className="sticky top-0 z-10 border-b border-zinc-200 bg-zinc-50/95 backdrop-blur"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="flex h-14 items-center gap-2 px-4">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            aria-label="Zurueck"
            className="-ml-2 inline-flex size-11 items-center justify-center rounded-lg text-zinc-900 active:bg-zinc-100 focus-visible:outline-2 focus-visible:outline-emerald-500 focus-visible:outline-offset-2"
          >
            <ArrowLeft aria-hidden="true" className="size-5" />
          </button>
        ) : null}
        <div className="min-w-0 flex-1">
          {eyebrow ? (
            <p className="truncate text-xs font-semibold uppercase tracking-wider text-zinc-600">
              {eyebrow}
            </p>
          ) : null}
          <h1 className="truncate text-base font-semibold text-zinc-900">{title}</h1>
        </div>
      </div>
    </header>
  );
}
